import { render, staticRenderFns } from "./PeppolRegistrationModal.vue?vue&type=template&id=02735739"
import script from "./PeppolRegistrationModal.vue?vue&type=script&lang=ts"
export * from "./PeppolRegistrationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02735739')) {
      api.createRecord('02735739', component.options)
    } else {
      api.reload('02735739', component.options)
    }
    module.hot.accept("./PeppolRegistrationModal.vue?vue&type=template&id=02735739", function () {
      api.rerender('02735739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/PeppolRegistrationModal.vue"
export default component.exports